export default "__VITE_PUBLIC_ASSET__89611f35__"